import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import "../assets/css/topo_mobile.css";
import { changeAbaNode } from "../main/home/homeActions";
import { getUserNode, isAuthenticatedNode } from "../services/auth_node";
import limpar_titulo from "../utils/home_functions/limpar_titulo";
import separa_em_area_corporativa from "../utils/home_functions/separa_em_area_corporativa";
import { abrevia_nome } from "../utils/Utils";
import VoittoCoins from "./VoittoCoinsNode";

class TopoMobileNode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      display: null,
      menu_deslogado_1: false,
      categorias: [
        {
          name: "Lean Seis Sigma",
          icon: "https://files.voitto.com.br/icon-lean.png",
          id: 1,
          area: "lean-seis-sigma",
        },
        {
          name: "Excelência Operacional",
          icon: "https://files.voitto.com.br/icon-excelencia.png",
          id: 2,
          area: "excelencia-operacional",
        },
        {
          name: "Softwares de Gestão",
          icon: "https://files.voitto.com.br/icon-softwares.png",
          id: 3,
          area: "softwares-de-gestao",
        },
        {
          name: "Sistemas de Gestão",
          icon: "https://files.voitto.com.br/icon-sistemas.png",
          id: 4,
          area: "sistemas-de-gestao",
        },
        {
          name: "Inovação & Cultura Ágil",
          icon: "https://files.voitto.com.br/icon-inovacao.png",
          id: 5,
          area: "inovacao-e-cultura-agil",
        },
        {
          name: "Desenvolvimento de Líderes",
          icon: "https://files.voitto.com.br/icon-lideres.png",
          id: 6,
          area: "desenvolvimento-de-lideres",
        },
        {
          name: "Negociação e Vendas",
          icon: "https://files.voitto.com.br/icon-negociacao.png",
          id: 7,
          area: "negociacao-e-vendas",
        },
        {
          name: "Gerenciamento de Projetos",
          icon: "https://files.voitto.com.br/icon-projetos.png",
          id: 9,
          area: "gerenciamento-de-projetos",
        },
      ],
      cursosByCat: false,
      menu_categoria: 0,
      cursos: [],
    };
  }

  EscondeElemento(id) {
    var elemento = document.getElementById(id);
    if (elemento.style.display == "none") {
      elemento.style.display = "block";
    } else {
      elemento.style.display = "none";
    }
  }

  componentDidMount() {
    if (isAuthenticatedNode) {
      const userNode = getUserNode();

      if (userNode) {
        this.setState({
          id: userNode.id,
          nome: userNode.nome,
          foto: userNode.foto,
          email: userNode.email,
          load: true,
        });
      }
    }
  }

  VerificaFoto() {
    if (
      getUserNode().foto == "" ||
      getUserNode().foto == null ||
      getUserNode().foto == 0 ||
      getUserNode().foto == undefined ||
      getUserNode().foto == "0" ||
      getUserNode().foto ==
        "https://files.voitto.com.br/ftp-files/assets/images/user_default.png"
    ) {
      return (
        "https://files.voitto.com.br/ftp-files/assets/images/perfil/" +
        getUserNode().nome.charAt(0).toUpperCase() +
        ".png"
      );
    } else {
      return getUserNode().foto;
    }
  }

  bar_foto() {
    //if (this.state.load) {
    return (
      <div
        style={{ marginRight: "3%", marginLeft: "5%", marginBottom: "-5px" }}
      >
        <img
          className="ui avatar circular image"
          alt="Perfil"
          src={this.VerificaFoto()}
        />
        <a className="ui" style={{ color: "white", textAlign: "center" }}>
          {abrevia_nome(getUserNode().nome)}
        </a>
        <i
          className="ellipsis vertical icon"
          id="icon-menu"
          onClick={() => {
            this.EscondeElemento("conf");
            this.EscondeElemento("conf1");
          }}
          style={{ float: "right", marginTop: "3%" }}
        ></i>
      </div>
    );
    //}
  }

  categoriasHabilita() {
    this.setState({ menu_deslogado_1: !this.state.menu_deslogado_1 });
  }

  activeCursosByCat(menu_categoria = 0) {
    setTimeout(() => {
      this.setState({
        menu_categoria,
      });
    }, 400);
  }

  resetSubmenu() {
    this.setState({
      menu_categoria: 0,
    });
  }

  renderCategorias() {
    return this.state.categorias.map((v) => (
      <div
        className={"divCategoria"}
        onMouseOver={() => this.activeCursosByCat(v.id)}
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          backgroundColor:
            this.state.menu_categoria == v.id ? "#f7f8fa" : "#FFF",
        }}
      >
        <div style={{ height: 20, width: "8%" }}>
          <img src={v.icon} style={{ width: 20, height: "100%" }} />
        </div>
        <div className="name-category">
          <p>{v.name}</p>
        </div>
        <div style={{ width: "5%" }}>
          <i className={"ui icon caret right"} />
        </div>
      </div>
    ));
  }

  returnSubCategoria() {
    return separa_em_area_corporativa(
      this.state.cursos.cursos,
      this.state.menu_categoria
    ).map((v) => {
      return (
        <a
          target="_blank"
          className="item-subcategoria"
          href={`/digital/${v.url_amigavel}`}
          style={{
            color: "black!important",
            display: "flex",
            lineHeight: 1.2,
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%",
            padding: 0,
            margin: 0,
          }}
        >
          <p style={{ color: "black" }}>{limpar_titulo(v.titulo)}</p>
        </a>
      );
    });
  }

  returnCategoriaById(id = 1, param = "") {
    let object = [];
    this.state.categorias.map((v) => {
      if (v.id == id) {
        if (param == "") {
          object = v;
        } else {
          object = v[param];
        }
      }
    });
    return object;
  }

  render() {
    return (
      <div
        style={{
          width: "100vw",
          position: "fixed",
          left: 0,
          right: 0,
          backgroundColor: "#000",
          top: 0,
          zIndex: 999999,
          padding: 10,
        }}
      >
        <div
          onClick={() => {
            this.setState({ display: !this.state.display });
          }}
          style={{
            zIndex: 10000,
            position: "absolute",
            left: 10,
            top: 15,
            padding: 10,
          }}
          className="item"
        >
          <i
            className="ui bars icon"
            style={{ color: "white", fontSize: 25 }}
          ></i>
        </div>
        <center>
          <a href="/">
            <img
              src="https://files.voitto.com.br/ftp-files/assets/images/voitto-white-full.png?size=200"
              style={{ width: 70, marginTop: 10 }}
            />
          </a>
          {isAuthenticatedNode() && (
            <a
              href="/sair"
              style={{
                color: "#fff",
                position: "absolute",
                right: "10px",
                top: "20px",
                padding: "10px",
              }}
            >
              <i className="sign in icon"></i>SAIR
            </a>
          )}
          {!isAuthenticatedNode() && (
            <a
              href="/login"
              style={{
                color: "#fff",
                position: "absolute",
                right: "10px",
                top: "20px",
                padding: "10px",
              }}
            >
              <i className="sign in icon"></i>LOGIN
            </a>
          )}
        </center>
        {isAuthenticatedNode() && (
          <div style={{ display: this.state.display ? "block" : "none" }}>
            <div id="item_droper">{this.bar_foto()}</div>
            <div id="conf" style={{ display: "none" }}>
              <div className="ui divider"></div>
              <p style={{ marginLeft: "6%", color: "white" }}>
                <VoittoCoins />
              </p>

              <div className="ui divider"></div>
              <a href="/online/editar-perfil">
                <p
                  id="item_droper"
                  style={{
                    margin: "0",
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <i className="edit outline icon" id="icon-menu"></i>EDITAR
                  PERFIL
                </p>
              </a>
              <div className="ui divider"></div>
              <a href="/online/pedidos">
                <p
                  id="item_droper"
                  style={{
                    margin: "0",
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <i className="shopping cart icon icon" id="icon-menu"></i>
                  PEDIDOS
                </p>
              </a>
              <div className="ui divider"></div>
              <a href="/online/meuscupons/">
                <p
                  id="item_droper"
                  style={{
                    margin: "0",
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <i className="tag icon mostarPremio icon" id="icon-menu"></i>
                  CUPONS
                </p>
              </a>
              <div className="ui divider"></div>
              <a href="/online/indique-e-ganhe">
                <p
                  id="item_droper"
                  style={{
                    margin: "0",
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <i className="handshake icon icon" id="icon-menu"></i>INDIQUE
                  E GANHE
                </p>
              </a>
              <div className="ui divider"></div>
              <a href="/online/certificados/">
                <p
                  id="item_droper"
                  style={{
                    margin: "0",
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <i className="student icon icon" id="icon-menu"></i>
                  CERTIFICADOS
                </p>
              </a>
              <div className="ui divider"></div>
              <a href="/">
                <p
                  id="item_droper"
                  style={{
                    margin: "0",
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <i className="book icon" id="icon-menu"></i>CURSOS
                </p>
              </a>
              <div className="ui divider"></div>
              <a href="https://app.slack.com/client/T010U77EFCY/C010J62B7DF">
                <p
                  id="item_droper"
                  style={{
                    margin: "0",
                    fontWeight: "500",
                    fontSize: "0.9rem",
                    textTransform: "uppercase",
                    color: "#fff",
                    textDecoration: "none",
                  }}
                >
                  <i className="globe icon" id="icon-menu"></i>ALUMNI VOITTO
                </p>
              </a>
              <div className="ui divider"></div>
            </div>
          </div>
        )}

        <div
          id="conf1"
          style={{
            position: "absolute",
            top: "100%",
            left: "0",
            width: "100%",
            overflowX: "hidden",
            height: "max-content",
            minHeight: "calc(100vh - 50px)",
            maxHeight: "calc(100vh - 100px)",
            overflowY: "scroll",
            marginTop: "0",
            marginLeft: this.state.display ? "0" : "-100%",
            zIndex: "10002 !important",
            backgroundColor: "#000000",
            transition: "0.4s ease-in-out",
            paddingBottom: "5rem",
            display: this.state.display ? "block" : "none",
          }}
        >
          <div className="ui divider"></div>

          <div id="div_input2">
            <form
              action="/busca"
              style={{
                width: "168%",
                display: "flex",
                height: "87%",
                marginLeft: "3%",
              }}
            >
              <input
                id="menu_input"
                name="filter"
                style={{
                  width: "100%",
                  textAlign: "center",
                }}
                className="portalSearchAntigo noti-searchAntigo load_aovivo load_voittocasts load_artigos load_materiais"
                type="text"
                placeholder="O que você quer aprender hoje?"
              />
              <button
                style={{
                  backgroundColor: "transparent",
                  border: "none",
                  marginLeft: "3%",
                }}
                type="submit"
              >
                <i className="inverted circular search link icon submit-pesquisa"></i>
              </button>
            </form>
          </div>
          <div
            style={{
              height: "20px",
            }}
          />
          <a id="sidebar_item" href="/sobrenos">
            <p
              id="item_droper"
              style={{
                margin: "0",
                fontWeight: "500",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              <i className="book icon" id="icon-menu"></i>SOBRE NÓS
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/cursos">
            <p
              id="item_droper"
              style={{
                margin: "0",
                fontWeight: "500",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              <i className="ui icon play" id="icon-menu"></i>TREINAMENTOS
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/lives">
            <p
              id="item_droper"
              style={{
                margin: "0",
                fontWeight: "500",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              <i className="ui icon red circle" id="icon-menu"></i> LIVES
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/workshops">
            <p
              id="item_droper"
              style={{
                margin: "0",
                fontWeight: "500",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              <i className="ui icon archive" id="icon-menu"></i> WORKSHOPS
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/certificacao/certificacao-green-e-black-belt-em-lean-seis-sigma">
            <p
              id="item_droper"
              style={{
                margin: "0",
                fontWeight: "500",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              <i className="certificate icon" id="icon-menu"></i>CERTIFICAÇÕES
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/empresas">
            <p
              id="item_droper"
              style={{
                margin: "0",
                fontWeight: "500",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              <i className="handshake icon" id="icon-menu"></i>ATENDIMENTO À
              EMPRESAS
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/historias-de-sucesso">
            <p
              id="item_droper"
              style={{
                margin: "0",
                fontWeight: "500",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              <i className="star icon" id="icon-menu"></i>HISTÓRIAS DE SUCESSO
            </p>
          </a>
          <div className="ui divider"></div>

          <a href="/blog">
            <p
              id="item_droper"
              style={{
                margin: "0",
                fontWeight: "500",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              <i className="globe icon" id="icon-menu"></i>CONTEÚDOS GRATUITOS
            </p>
          </a>

          <div className="ui divider"></div>
          <a href="/faq">
            <p
              id="item_droper"
              style={{
                margin: "0",
                fontWeight: "500",
                fontSize: "0.9rem",
                textTransform: "uppercase",
                color: "#fff",
                textDecoration: "none",
              }}
            >
              <i className="comments outline icon" id="icon-menu"></i>CENTRAL DE
              AJUDA
            </p>
          </a>
          <div className="ui divider"></div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({ myaba: store.home.aba });
const mapDispathToProps = (dispatch) =>
  bindActionCreators({ changeAbaNode }, dispatch);
export default connect(mapStateToProps, mapDispathToProps)(TopoMobileNode);
